import { Notification, NotificationsGroup } from "@vwfs-bronson/bronson-react";
import { useNotification } from "../../hooks/useNotification";

export const Notifications = () => {
  const { notifications, handleCloseNotification } = useNotification();
  return (
    <>
      {notifications &&
        notifications.map((x, index) => {
          if (x.expiracy && x.expiracy < new Date()) return;
          return (
            <NotificationsGroup key={`Notification_${index}`} className="u-mv">
              <Notification
                showCloseButton
                onCloseClick={() => handleCloseNotification(x)}
                status={x.status}
                title={x.title ?? ""}
                hideTitle={!x.title}
                visible
              >
                {x.body}
              </Notification>
            </NotificationsGroup>
          );
        })}
    </>
  );
};
export default Notifications;
